import { UtilityService } from '@eforall/common';
import { buildColumn, GridColumn } from '@eforall/dashboard';
import { VolunteerSpecialistSignup } from '../specialist-signups-dialog.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<VolunteerSpecialistSignup, unknown>[] = [
		buildColumn(util, 'Text', row => row.trimesterName, { header: 'Trimester', group: { order: 1, dir: 'desc' } }),
		buildColumn(util, 'Text', row => row.topicName, { header: 'Topic' }),
		buildColumn(util, 'Text', row => row.language, { header: 'Language' }),
		buildColumn(util, 'Status', row => row.status, { header: 'Status' }),
		buildColumn(util, 'Text', row => util.date.formatUTC(row.availableClassStartTimeUTC, 'MMM D, YYYY', 'H:MM AM EST', 'en-US'), { header: 'Available Start', sort: { order: 2, dir: 'desc' } }),
		buildColumn(util, 'Text', row => util.date.formatUTC(row.availableClassEndTimeUTC, 'MMM D, YYYY', 'H:MM AM EST', 'en-US'), { header: 'Available End' }),
	];

	return columns;

}